import { GraphQL } from "@graphql/graphQL";
import { UpdateApplianceListMutation, UpdateApplianceListMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultUpdateApplianceListOptions: MutationHookOptions<UpdateApplianceListMutation, UpdateApplianceListMutationVariables> = {

};

export const useUpdateApplianceList = (options?: MutationHookOptions<UpdateApplianceListMutation, UpdateApplianceListMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: UpdateApplianceListMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<UpdateApplianceListMutation, UpdateApplianceListMutationVariables>(GraphQL.updateApplianceList);

    const updateApplianceList = async (variables: UpdateApplianceListMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultUpdateApplianceListOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (error) {
            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        updateApplianceList
    };
};
